var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8724 5.3849C12.2599 2.6899 9.90905 1.47656 7.84405 1.47656C7.84405 1.47656 7.84405 1.47656 7.83822 1.47656C5.77905 1.47656 3.42238 2.68406 2.80988 5.37906C2.12738 8.38906 3.97072 10.9382 5.63905 12.5424C6.25738 13.1374 7.05072 13.4349 7.84405 13.4349C8.63738 13.4349 9.43072 13.1374 10.0432 12.5424C11.7115 10.9382 13.5549 8.3949 12.8724 5.3849ZM7.84405 8.3074C6.82905 8.3074 6.00655 7.4849 6.00655 6.4699C6.00655 5.4549 6.82905 4.6324 7.84405 4.6324C8.85905 4.6324 9.68155 5.4549 9.68155 6.4699C9.68155 7.4849 8.85905 8.3074 7.84405 8.3074Z",
    fill: "#445386"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.b5c95e87ca101d51d010b518f9f3e492.svg";
export { ForwardRef as ReactComponent };